import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';

export const DISABLED: BlockOverrides = {
  Block: {
    style: {
      marginTop: 0,
      marginBottom: 0,
      fontSize: '18px',
      userSelect: 'none',
      msUserSelect: 'none',
      MozUserSelect: 'none',
      KhtmlUserSelect: 'none',
      WebkitUserSelect: 'none',
      WebkitTouchCallout: 'none',
      whiteSpace: 'pre-wrap',
      lineHeight: '1.25em',

      [THEME.media.large]: {
        fontSize: '20px',
      },
    },
  },
};

export const HEADING: BlockOverrides = {
  Block: {
    style: {
      marginTop: 0,
      marginBottom: 0,
      fontSize: '18px',
      whiteSpace: 'pre-wrap',
      lineHeight: '1.25em',

      [THEME.media.large]: {
        fontSize: '20px',
      },
    },
  },
};

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      width: 'calc(100% - 64px)',
      backgroundColor: '#161519',
      paddingLeft: '32px',
      paddingBottom: '32px',
      paddingTop: '32px',
      paddingRight: '32px',
      marginTop: '16px',
      marginBottom: '16px',
    },
  },
};

export const QUESTION: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      flexDirection: 'column-reverse',

      [THEME.media.large]: {
        display: 'grid',
        justifyContent: 'space-between',
        gridTemplateColumns: 'auto auto',
        gridColumnGap: '64px',
      },
    },
  },
};

export const SCORE: BlockOverrides = {
  Block: {
    style: {
      marginTop: 0,
      marginBottom: '16px',
      fontSize: '16px',
      textAlign: 'right',

      [THEME.media.large]: {
        marginTop: 0,
        marginBottom: 0,
        fontSize: '20px',
      },
    },
  },
};
